import { Box, Card } from "@mui/material";
import PropTypes from "prop-types";

const DetailSectionContent = ({ children, variant = "card", sx = {} }) => {
  if (variant === "card") {
    return (
      <Card
        // elevation={0}
        sx={{
          // borderRadius: "0 0 4px 4px",
          // border: "1px solid #e5e7eb",
          // borderTop: "none",
          padding: 2,
          ...sx,
        }}
      >
        {children}
      </Card>
    );
  }
  if (variant === "outline") {
    return (
      <Card
        // elevation={0}
        sx={{
          // borderRadius: "0 0 4px 4px",
          // border: "1px solid #e5e7eb",
          // borderTop: "none",
          boxShadow: "none",
          border: "1px solid #e5e7eb",
          padding: 2,
          ...sx,
        }}
      >
        {children}
      </Card>
    );
  }

  // Flat variant
  return (
    <Box
      sx={{
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

DetailSectionContent.propTypes = {
  /** Content to render inside the section */
  children: PropTypes.node.isRequired,
  /** Visual variant - card adds a bordered container, flat has no container */
  variant: PropTypes.oneOf(["card", "flat"]),
  /** Optional MUI sx prop for custom styling */
  sx: PropTypes.object,
};
export default DetailSectionContent;
